import { Spinner } from '@smartsash/ui';
import { useTranslation } from 'react-i18next';

import styles from './RoutePending.module.css';

/** Diameter of the route-level spinner; larger than the inline default. */
const SPINNER_SIZE_PX = 32;

/**
 * Router-wide pending fallback (HS-869).
 *
 * Registering it as `defaultPendingComponent` is what makes TanStack Router wrap a match in
 * `<Suspense>` at all — without it the `useSuspenseQuery` reads inside `@smartsash/data-screen`
 * have no boundary to suspend to. `_dashboard.tsx` keeps its own `pendingComponent` for the
 * session restore; this one covers every screen below it.
 */
export function RoutePending() {
  const { t } = useTranslation();

  return (
    <div className={styles.pending}>
      <Spinner size={SPINNER_SIZE_PX} label={t('route.loading')} />
    </div>
  );
}
